import { render, staticRenderFns } from "./CompanyNames.vue?vue&type=template&id=412440ff&scoped=true"
import script from "./CompanyNames.vue?vue&type=script&lang=js"
export * from "./CompanyNames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412440ff",
  null
  
)

export default component.exports